import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// components
import OverlayLoader from '../../../parts/OverlayLoader';
import InPersonPaymentPanel from './InPersonPaymentPanel';
import PayPalPaymentPanel from './PayPalPaymentPanel';

//actions
import { getAmountForOrder } from '../../../actions/payment';
import AdyenPaymentPanel from './AdyenPaymentPanel';

class HandlePaymentCard extends Component {
  constructor(props) {
    super(props);

    this.state = this.createDefaultState();
    this.createDefaultState = this.createDefaultState.bind(this);
    this.resetPaymentErrors = this.resetPaymentErrors.bind(this);
  }

  createDefaultState(paymentError = '') {
    return Object.assign({}, {
      paymentError: null,
    });
  }

  handleChangePaymentType(paymentType) {
    this.resetPaymentErrors();
    this.props.setPaymentType(paymentType);
    this.props.onCheckUpdateAmount();
  }


  resetPaymentErrors() {
    this.setState({ paymentError: '' });
  }

  renderAmount() {
    const { totalBalance, loadingAmount } = this.props;

    if (loadingAmount) {
      return (
        <div className="u-margin-bottom-medium u-margin-top-medium ">
          <OverlayLoader active />
        </div>
      );
    }

    return totalBalance ? (
      <div className="u-padding-top-micro">£{totalBalance.toFixed(2)}</div>
    ) : null;
  }


  render() {
    const { loadingAmount, paymentType, isSofologist, orderIdx,
      amountToPay, orderData, orderRef, orderNo, isPaymentAvailable, user, paymentTypeButtonDisabled } = this.props;

    const showDefaultPage = paymentType === 'none';
    const showCardPayment = paymentType === 'standard' && amountToPay > 0;
    const showPayPal = paymentType === 'paypal';
    const showInPerson = isSofologist && ['pdq', 'cash'].includes(paymentType);

    return (
      <div className="payment_card">
        <div className='payment_card__balance-container'>
          <div className="payment_card__balance-amount u-padding-y-medium">
            <div className="h4 u-text-center u-margin-reset">Please pay your balance:</div>
            <div className="h2 u-flex-center-both u-margin-reset">
              {this.renderAmount()}
            </div>
          </div>
          <div className="h2 u-flex-center-both u-margin-reset">
            {this.props.payBalanceInputComponent()}
          </div>
        </div>

        <div className='payment_card__payments-container'>
          {!loadingAmount && <div className='payment_card__payments'>
            {/* PaymentTypeSelector */}
            {!isSofologist && (
              <div className="c-tab-bar">
                <button
                  className={`c-tab-bar__tab  c-tab-bar__tab__footer ${paymentType === 'standard' ? 'c-tab-bar__tab__footer--active  c-tab-bar__tab__footer--active-right' : ''} u-padding-small`}
                  onClick={() => this.handleChangePaymentType('standard')}
                  disabled={paymentTypeButtonDisabled}
                >
                  CARD
                </button>

                <button
                  className={`c-tab-bar__tab  c-tab-bar__tab__footer ${paymentType === 'paypal' ? 'c-tab-bar__tab__footer--active  c-tab-bar__tab__footer--active-right' : ''} u-padding-small`}
                  onClick={() => this.handleChangePaymentType('paypal')}
                  disabled={paymentTypeButtonDisabled}
                >
                  PAYPAL
                </button>
              </div>)}

            {/* payment handler error notifications */}
            {this.state.paymentError ? (
              <div className="u-padding-medium u-padding-bottom-micro u-padding-top-small u-text-center u-text-error">
                {this.state.paymentError}
              </div>
            ) : null}

            {/* Default page */}
            {showDefaultPage && (
              <div
                className="u-margin-top-tiny u-margin-bottom"
              >
                {(!loadingAmount && isPaymentAvailable) && (
                  <div
                    className="u-padding-top u-padding-bottom-small u-text-center c-event-feed__card__extra-info"
                  >
                    Please select a <strong>payment method</strong>
                  </div>
                )}
                {loadingAmount && (
                  <div
                    className="u-padding-top u-padding-bottom-small u-text-center c-event-feed__card__extra-info"
                  >
                    One moment please we are checking your <strong>order</strong>.
                  </div>)}

              </div>
            )}

            {/* PayPal payment */}
            {showPayPal && (
              <div className="u-padding">
                <PayPalPaymentPanel
                  orderIdx={orderIdx}
                  amount={amountToPay}
                  orderData={orderData}
                  orderRef={orderRef}
                  orderNo={orderNo}
                  loadingAmount={loadingAmount}
                  onStartPayment={this.resetPaymentErrors}
                  onComplete={this.props.onCheckUpdateAmount}
                  onError={(error) => {
                    this.setState(this.createDefaultState(error));
                    this.props.onCheckUpdateAmount();
                  }}
                />
              </div>
            )}

            {/* Sofologist in person payment verification panel */}
            {showInPerson && (
              <div className="u-padding-medium u-padding-top-small">
                <InPersonPaymentPanel
                  orderIdx={orderIdx}
                  amountToPay={amountToPay}
                  loadingAmount={loadingAmount}
                  paymentType={paymentType}
                  onComplete={this.props.onCheckUpdateAmount}
                  onError={error => this.setState(this.createDefaultState(error))}
                />
              </div>
            )}

            {/* standard credit/dedit card payment form */}
            {showCardPayment && (
              <div className="u-padding-medium u-padding-top-small">
                <AdyenPaymentPanel
                  orderData={orderData}
                  amount={amountToPay}
                  orderIdx={orderIdx}
                  orderRef={orderRef}
                  orderNo={orderNo}
                  userGuid={user.userGuid}
                  isSofologist={isSofologist}
                  loadingAmount={loadingAmount}
                  onComplete={this.props.onCheckUpdateAmount}
                />
              </div>
            )}

          </div>}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  isSofologist: state.sofologist.Authorized,
  sofologist: state.sofologist
});

const mapDispatchToProps = dispatch => bindActionCreators({
  getAmountForOrder
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(HandlePaymentCard);



// WEBPACK FOOTER //
// ./src/cards/templates/payBalanceSections/HandlePaymentCard.js